import React from 'react';
import Theme from 'react-common/theme';
import ErrorBoundary from 'react-components/ErrorBoundary';
import { BrowserRouter as Router } from 'react-router-dom';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import ThemeProvider from '@material-ui/styles/ThemeProvider';
import ExcursionToolbarContainer from './ExcursionToolbarContainer';
export default function ExcursionToolbarRoot(params) {
    return (React.createElement(ErrorBoundary, null,
        React.createElement(ThemeProvider, { theme: Theme },
            React.createElement(MuiPickersUtilsProvider, { utils: MomentUtils },
                React.createElement(Router, null,
                    React.createElement(ExcursionToolbarContainer, { excursionId: params.excursionId }))))));
}
